// ═══════════════════════════════════════════════════════════════════════════
// alcanceEquipo — qué empresas hereda alguien por el organigrama (espejo)
// ═══════════════════════════════════════════════════════════════════════════
// Espejo de functions/lib/alcanceEquipo.js: la UI decide el alcance con la
// misma regla que el servidor, para no habilitar lo que el servidor niega. La
// explicación completa (el agujero del report wpT730o6P259ZCQoV4QH) está en esa
// cabecera. Resumen: el staff hereda su equipo entero; un no-staff hereda sólo
// lo que ya está en sus propias `empresaIds`.
// Las dos puntas las ata alcanceEquipo.paridad.test.js contra una tabla dorada.
// ═══════════════════════════════════════════════════════════════════════════

/**
 * @param {{ esStaff: boolean, empresasEquipo?: string[], empresaIds?: string[] }} u
 * @returns {string[]} las empresas que el organigrama le suma a su alcance
 */
export function empresasHeredadasPorEquipo({ esStaff, empresasEquipo, empresaIds }) {
  if (!Array.isArray(empresasEquipo)) return []
  if (esStaff === true) return [...empresasEquipo]
  const propias = new Set(Array.isArray(empresaIds) ? empresaIds : [])
  return empresasEquipo.filter((e) => propias.has(e))
}
